<ng-template #noSecretsPanel>
  <div
    class="no-secrets-panel"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()"
    (keypress)="$event.stopPropagation()"
  >
    <div class="no-secrets-title">No secrets available</div>
    <div class="no-secrets-subtitle">
      You need to create a secret first on the Settings page.
    </div>
    <button
      mat-stroked-button
      type="button"
      class="no-secrets-action"
      (click)="goToSettings.emit(); $event.stopPropagation()"
    >
      Go to Secrets
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</ng-template>

<mat-form-field appearance="outline" [ngClass]="fieldClass()">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="control()">
    @if (secrets().length > 0) {
      <mat-option value="">Select a secret</mat-option>
      @for (secret of secrets(); track secret.secretId) {
        <mat-option [value]="secret.secretId">
          {{ secret.name }}
        </mat-option>
      }
    }
    @if (secrets().length === 0) {
      <mat-option disabled [value]="">
        <ng-container *ngTemplateOutlet="noSecretsPanel"></ng-container>
      </mat-option>
    }
  </mat-select>
  @if (error()) {
    <mat-error>{{ error() }}</mat-error>
  }
</mat-form-field>
